export const ADD_POST = "ADD_POST";
export const REMOVE_POST = "REMOVE_POST";
export const UPDATE_POST = "UPDATE_POST";

export const FETCH_USER_POSTS_REQUEST = "FETCH_USER_POSTS_REQUEST";
export const FETCH_USER_POSTS_SUCCESS = "FETCH_USER_POSTS_SUCCESS";
export const FETCH_USER_POSTS_FAILURE = "FETCH_USER_POSTS_FAILURE";

export const FETCH_ESP_POSTS_REQUEST = "FETCH_ESP_POSTS_REQUEST";
export const FETCH_ESP_POSTS_SUCCESS = "FETCH_ESP_POSTS_SUCCESS";
export const FETCH_ESP_POSTS_FAILURE = "FETCH_ESP_POSTS_FAILURE";

export const FETCH_INV_POSTS_REQUEST = "FETCH_INV_POSTS_REQUEST";
export const FETCH_INV_POSTS_SUCCESS = "FETCH_INV_POSTS_SUCCESS";
export const FETCH_INV_POSTS_FAILURE = "FETCH_INV_POSTS_FAILURE";

export const FETCH_ALL_POSTS_REQUEST = "FETCH_ALL_POSTS_REQUEST";
export const FETCH_ALL_POSTS_SUCCESS = "FETCH_ALL_POSTS_SUCCESS";
export const FETCH_ALL_POSTS_FAILURE = "FETCH_ALL_POSTS_FAILURE";

export const fetchUserPostsRequest = () => {
  return {
    type: FETCH_USER_POSTS_REQUEST,
  };
};

export const fetchUserPostsSuccess = (data) => {
  return {
    type: FETCH_USER_POSTS_SUCCESS,
    payload: data,
  };
};

export const fetchUserPostsFailure = (error) => {
  return {
    type: FETCH_USER_POSTS_FAILURE,
    payload: error,
  };
};

/////////////ESP////////////////////

export const fetchEspPostsRequest = () => {
  return {
    type: FETCH_ESP_POSTS_REQUEST,
  };
};

export const fetchEspPostsSuccess = (data) => {
  return {
    type: FETCH_ESP_POSTS_SUCCESS,
    payload: data,
  };
};

export const fetchEspPostsFailure = (error) => {
  return {
    type: FETCH_ESP_POSTS_FAILURE,
    payload: error,
  };
};

/////////////INVOICES////////////////////

export const fetchInvPostsRequest = () => {
  return {
    type: FETCH_INV_POSTS_REQUEST,
  };
};

export const fetchInvPostsSuccess = (data) => {
  return {
    type: FETCH_INV_POSTS_SUCCESS,
    payload: data,
  };
};

export const fetchInvPostsFailure = (error) => {
  return {
    type: FETCH_INV_POSTS_FAILURE,
    payload: error,
  };
};

////////////ALL POSTS////////////////////

export const fetchAllPostsRequest = () => {
  return {
    type: FETCH_ALL_POSTS_REQUEST,
  };
};

export const fetchAllPostsSuccess = (data) => {
  return {
    type: FETCH_ALL_POSTS_SUCCESS,
    payload: data,
  };
};

export const fetchAllPostsFailure = (error) => {
  return {
    type: FETCH_ALL_POSTS_FAILURE,
    payload: error,
  };
};
